import { TRAY_COUNT } from './types.js';
export const asTray = (n) => (((n % TRAY_COUNT) + TRAY_COUNT) % TRAY_COUNT);
/** Which tray receives the last marker when `moved` markers leave `source`. */
export function targetOf(source, moved) {
    return asTray(source + moved);
}
/** True when `order` is a rearrangement of exactly the markers in `tray`. */
export function isPermutationOf(order, tray) {
    if (order.length !== tray.length)
        return false;
    const counts = new Map();
    for (const c of tray)
        counts.set(c, (counts.get(c) ?? 0) + 1);
    for (const c of order) {
        const n = counts.get(c) ?? 0;
        if (n === 0)
            return false;
        counts.set(c, n - 1);
    }
    return true;
}
/**
 * Pick up every marker in `source` and drop them one per tray clockwise,
 * in the order given by `colorOrder` (default: the order they sit in the tray).
 * Returns null if the tray is empty or the colour order does not match.
 */
export function distribute(trays, source, colorOrder) {
    const picked = trays[source];
    if (!picked || picked.length === 0)
        return null;
    const order = colorOrder ? [...colorOrder] : [...picked];
    if (!isPermutationOf(order, picked))
        return null;
    const next = trays.map((t) => [...t]);
    next[source] = [];
    order.forEach((color, i) => {
        const idx = asTray(source + i + 1);
        next[idx].push(color);
    });
    return {
        trays: next,
        source,
        target: targetOf(source, order.length),
        moved: order.length,
        colorOrder: order,
    };
}
/** A Trajan tile is satisfied when the tray holds both of its colours (as a multiset). */
export function trajanTileSatisfied(tile, tray) {
    const [a, b] = tile.colors;
    if (a === b)
        return tray.filter((c) => c === a).length >= 2;
    return tray.includes(a) && tray.includes(b);
}
/** What choosing `source` would do for this player, without changing anything. */
export function previewTray(player, source, slotBesideTray) {
    const d = distribute(player.trays, source);
    if (!d)
        return null;
    const slot = slotBesideTray[d.target];
    const tile = player.trajanSlots[slot] ?? null;
    return {
        source,
        target: d.target,
        moved: d.moved,
        trajanTile: tile
            ? { slot, tile, satisfied: trajanTileSatisfied(tile, d.trays[d.target]) }
            : null,
    };
}
//# sourceMappingURL=tray.js.map